import { type Object3D, Vector3 } from 'three/webgpu';

/**
 * Camera-relative rendering. The three.js camera always sits at the scene
 * origin; every anchored object is placed at (universePosition − camera),
 * computed in f64 on the CPU. Only small numbers ever reach the GPU, so a world
 * 10,000 km from the universe origin renders without jitter.
 */
export class RenderOrigin {
  /** Universe position of the render camera. */
  readonly camera = new Vector3();
  private readonly anchored = new Map<Object3D, Vector3>();

  /** Keep `object` at universe position `position` (the vector is referenced, not copied). */
  anchor(object: Object3D, position: Vector3): void {
    this.anchored.set(object, position);
  }

  unanchor(object: Object3D): void {
    this.anchored.delete(object);
  }

  toRender(universe: Vector3, out: Vector3): Vector3 {
    return out.subVectors(universe, this.camera);
  }

  update(cameraUniverse: Vector3): void {
    this.camera.copy(cameraUniverse);
    for (const [object, position] of this.anchored) {
      object.position.subVectors(position, this.camera);
    }
  }
}
